module.exports = __webpack_public_path__ + "static/media/codejam_talks.5d00572f.jpeg";